export interface ICameraStreamSource {
  type: StreamSourceType;
  rtspConfig?: IRtspCameraStreamConfig;
  reolinkConfig?: IReolinkCameraStreamConfig;
  nexShieldConfig?: INexShieldCameraStreamConfig;
}

export enum StreamSourceType {
  Rtsp = 'Rtsp',
  Reolink = 'Reolink',
  NexShield = 'NexShield',
}

export interface IRtspCameraStreamConfig {
  url: string;
  username?: string;
  password?: string;
}

export interface IReolinkCameraStreamConfig {
  cameraId: string;
}

export interface INexShieldCameraStreamConfig {
  domainId: number;
  cameraId: string;
}
